import { useState, useEffect } from "react";

const slides = [
  {
    bg: "https://www.archiconservices.com/img/slider/1.jpg",
  },
  {
    bg: "https://www.archiconservices.com/img/slider/2.jpg",
  },
  {
    bg: "https://www.archiconservices.com/img/slider/3.jpg",
  },
  {
    bg: "https://www.archiconservices.com/img/slider/4.jpg",
  },
];

export default function Hero() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const handleScroll = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="home" className="relative w-full h-screen min-h-[700px] overflow-hidden">
      {/* Background Slides */}
      {slides.map((slide, i) => (
        <div
          key={i}
          className="absolute inset-0 transition-opacity duration-1000"
          style={{
            opacity: i === current ? 1 : 0,
            backgroundImage: `url(${slide.bg})`,
            backgroundSize: "cover",
            backgroundPosition: "center top",
          }}
        />
      ))}

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/65" />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6 w-full">
        {/* Label */}
        <div
          className="inline-flex items-center gap-2 border border-white/30 text-white/80 text-xs tracking-widest uppercase px-4 py-1.5 rounded-full mb-8"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          <span className="w-1.5 h-1.5 rounded-full bg-amber-400 inline-block"></span>
          Houston, Texas — Est. 2007
        </div>

        {/* H1 */}
        <h1
          className="text-white text-4xl md:text-6xl lg:text-7xl font-light leading-tight max-w-5xl mb-6"
          style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: "-0.01em" }}
        >
          Architectural Design That Elevates{" "}
          <em className="not-italic font-semibold">Form, Function,</em>{" "}
          and Experience
        </h1>

        {/* Subheadline */}
        <p
          className="text-white/75 text-base md:text-lg font-light max-w-2xl mb-3 leading-relaxed"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Archicon Services delivers thoughtful, high-performance architectural design solutions for residential and commercial spaces.
        </p>
        <p
          className="text-white/55 text-sm md:text-base font-light max-w-xl mb-12 leading-relaxed"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Blending creativity, technical precision, and real-world functionality to bring visionary spaces to life.
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); handleScroll("#contact"); }}
            className="bg-white text-stone-900 text-xs tracking-widest uppercase px-8 py-4 rounded-sm hover:bg-stone-100 transition-colors duration-300 cursor-pointer whitespace-nowrap font-medium"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Start Your Design Consultation
          </a>
          <a
            href="#services"
            onClick={(e) => { e.preventDefault(); handleScroll("#services"); }}
            className="border border-white/50 text-white text-xs tracking-widest uppercase px-8 py-4 rounded-sm hover:bg-white/10 transition-colors duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            View Our Work
          </a>
        </div>

        {/* Mobile Call CTA */}
        <a
          href="tel:+17139276666"
          className="mt-8 flex items-center gap-2 text-white/80 text-sm font-medium cursor-pointer hover:text-white transition-colors duration-300 md:hidden"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          <span className="w-8 h-8 flex items-center justify-center rounded-full border border-white/40">
            <i className="ri-phone-line text-sm"></i>
          </span>
          Call Now: (713) 927-6666
        </a>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`h-0.5 transition-all duration-500 cursor-pointer ${
              i === current ? "w-8 bg-white" : "w-4 bg-white/40"
            }`}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>

      {/* Scroll hint */}
      <div className="absolute bottom-8 right-10 hidden md:flex flex-col items-center gap-2 z-10">
        <span
          className="text-white/40 text-xs tracking-widest uppercase"
          style={{ fontFamily: "'Inter', sans-serif", writingMode: "vertical-rl" }}
        >
          Scroll
        </span>
        <div className="w-px h-12 bg-white/20"></div>
      </div>
    </section>
  );
}
